import { trialExperienceDashboardPermission } from "./constants";
import { userHasRight } from "./helperMethods";

/**
 * Sponsor org feature flags from Redux `loggedInUser.userDetails` (set on login in Layout).
 * Keys align with admin Settings / subscription_information: has_trial_experience, has_chat_diligent.
 * When absent, treat as disabled.
 */
function isTruthyOrgDetail(value) {
  return value === true || value === "true";
}

/** @param {{ userDetails?: Record<string, unknown> } | null | undefined} loggedInUser - Redux `state.loggedInUser` */
export function isOrgTrialExperienceEnabled(loggedInUser) {
  return isTruthyOrgDetail(loggedInUser?.userDetails?.has_trial_experience);
}

/** Org trial flag from an API profile object (e.g. react-query before Redux is hydrated). */
export function isOrgTrialExperienceEnabledFromProfile(sponsorProfile) {
  return isTruthyOrgDetail(sponsorProfile?.has_trial_experience);
}

/** @param {{ userDetails?: Record<string, unknown> } | null | undefined} loggedInUser */
export function isOrgChatDiligentEnabled(loggedInUser) {
  return isTruthyOrgDetail(loggedInUser?.userDetails?.has_chat_diligent);
}

/** Org flag from logged-in sponsor profile AND per-user right (SponsorRights / Redux). */
export function canUseTrialExperienceDashboard(loggedInUser, rights) {
  return (
    isOrgTrialExperienceEnabled(loggedInUser) &&
    userHasRight(rights || [], trialExperienceDashboardPermission)
  );
}

/**
 * Org flag from logged-in sponsor profile AND per-user chat access on the same payload
 * (`userDetails.chat_diligent_access`).
 */
export function canUseChatDiligent(loggedInUser) {
  const d = loggedInUser?.userDetails;
  return (
    isOrgChatDiligentEnabled(loggedInUser) && d?.chat_diligent_access === true
  );
}
